<template>
    <div>
        <h2 class="title-main">{{ $t("message.our_news") }}</h2>

        <div class="items-slider" ref="items-slider">
            <Splide ref="splide" :extensions="extensions" :has-track="false" :options="options">
                <SplideTrack>
                    <SplideSlide>
                        <div @click="displayFocusProject(1)">
                            <div>
                                <div class="media">
                                    <img src="/refs/image_yookan_001.png" alt="" />
                                </div>
                                <div class="title">
                                    <Focus />
                                    <span>{{ $t("message.project_focus_1") }}</span>
                                </div>
                                <div class="desc">
                                    <span v-html="$t('message.intro_project_focus_1')"></span>
                                </div>
                                <div class="see">
                                    <span>{{ $t("message.see") }}</span>
                                </div>
                            </div>
                        </div>
                    </SplideSlide>
                    <SplideSlide>
                        <div @click="displayFocusProject(2)">
                            <div>
                                <div class="media">
                                    <img src="/refs/innovation_framework_01.png" alt="" />
                                </div>
                                <div class="title">
                                    <HotTrend />
                                    <span>{{ $t("message.project_focus_2") }}</span>
                                </div>
                                <div class="desc">
                                    <span v-html="$t('message.intro_project_focus_2')"></span>
                                </div>
                                <div class="see">
                                    <span>{{ $t("message.see") }}</span>
                                </div>
                            </div>
                        </div>
                    </SplideSlide>
                    <SplideSlide>
                        <div @click="displayFocusProject(3)">
                            <div>
                                <div class="media">
                                    <img src="/refs/lab.png" alt="" />
                                </div>
                                <div class="title">
                                    <Lab />
                                    <span>{{ $t("message.project_focus_3") }}</span>
                                </div>
                                <div class="desc">
                                    <span v-html="$t('message.intro_project_focus_3')"></span>
                                </div>
                                <div class="see">
                                    <span>{{ $t("message.see") }}</span>
                                </div>
                            </div>
                        </div>
                    </SplideSlide>
                    <SplideSlide>
                        <div @click="displayFocusProject(4)">
                            <div>
                                <div class="media">
                                    <img src="/refs/image_challenge_001.png" alt="" />
                                </div>
                                <div class="title">
                                    <Lab />
                                    <span>{{ $t("message.project_focus_4") }}</span>
                                </div>
                                <div class="desc">
                                    <span v-html="$t('message.intro_project_focus_4')"></span>
                                </div>
                                <div class="see">
                                    <span>{{ $t("message.see") }}</span>
                                </div>
                            </div>
                        </div>
                    </SplideSlide>
                    <SplideSlide>
                        <div @click="displayFocusProject(5)">
                            <div>
                                <div class="media">
                                    <img src="/refs/5426815.png" alt="" />
                                </div>
                                <div class="title">
                                    <Lab />
                                    <span>{{ $t("message.project_focus_5") }}</span>
                                </div>
                                <div class="desc">
                                    <span v-html="$t('message.intro_project_focus_5')"></span>
                                </div>
                                <div class="see">
                                    <span>{{ $t("message.see") }}</span>
                                </div>
                            </div>
                        </div>
                    </SplideSlide>
                    <!--<SplideSlide>
                        <div @click="displayFocusProject(6)">
                            <div>
                                <div class="media">
                                    <img src="/refs/quaistion.png" alt="" />
                                </div>
                                <div class="title">
                                    <Lab />
                                    <span>{{ $t("message.project_focus_6") }}</span>
                                </div>
                                <div class="desc">
                                    <span v-html="$t('message.intro_project_focus_6')"></span>
                                </div>
                                <div class="see">
                                    <span>{{ $t("message.see") }}</span>
                                </div>
                            </div>
                        </div>
                    </SplideSlide>
                    <SplideSlide>
                        <div @click="pageRefs()" class="more-ref">
                            <div>
                                <div class="img">
                                    <span><Plus /></span>
                                </div>
                                <div class="more">
                                    <span v-html="$t('message.more_ref')"></span>
                                </div>
                            </div>
                        </div>
                    </SplideSlide>-->
                </SplideTrack>
            </Splide>
        </div>
    </div>
</template>

<script>
import { Splide, SplideSlide, SplideTrack } from "@splidejs/vue-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "@splidejs/vue-splide/css";

import Focus from "./img/Focus.vue";
import Drag from "./img/Drag.vue";
import HotTrend from "./img/HotTrend.vue";
import Lab from "./img/Lab.vue";
import Play from "./img/Play.vue";
import Plus from "./img/Plus.vue";

export default {
    name: "ItemsSlider",
    data() {
        return {
            local: "fr",
            indexRef: 0,
            splideScrolling: false,
            newPosX: 0,
            newPosY: 0,
            zoneCircleActive: false,

            extensions: { AutoScroll },
            options: {
                //type: "loop",
                drag: "free",
                pagination: false,
                arrows: false,
                autoScroll: {
                    rewind: true,
                    speed: 0.5,
                    pauseOnHover: true,
                },
                perPage: 4,

                breakpoints: {
                    1400: { perPage: 3 },
                    1100: { perPage: 2 },
                    768: { perPage: 1, pagination: true },
                },
            },
        };
    },
    components: {
        Focus,
        HotTrend,
        Lab,
        Play,
        Plus,
        Splide,
        SplideSlide,
        SplideTrack,
        Drag,
        AutoScroll,
    },
    mounted() {
        this.local = this.$i18n.locale;
    },
    watch: {
        "$i18n.locale": function (locale) {
            this.filterMetier = "";
            this.filterSujet = "";
            this.filterDispositif = "";
            this.local = locale;
        },
    },
    methods: {
        displayFocusProject(idx) {
            this.$store.dispatch("app/setResetVideoHome", true);

            this.$store.dispatch("app/displayModal", {
                display: true,
                name: "reference",
                content: this.$store.getters["app/getRef"](this.local, idx),
            });
        },
        displayGame(index) {
            this.$store.dispatch("app/setResetVideoHome", true);

            this.$store.dispatch("app/displayModal", {
                display: true,
                name: "game",
                content: this.$store.state.app.games[this.local][index],
            });
        },
        pageRefs() {
            const url = "./references";
            window.location.href = url;
        },
    },
};
</script>

<style lang="scss">
.items-slider {
    cursor: url(@/assets/img/drag.png), pointer;
}
.items-slider .splide__track {
    position: relative;
    padding: 3rem 0 4rem;
}
.items-slider .splide__pagination {
    bottom: -1.5em;
}

.items-slider .splide__slide {
    transition: all 0.5s;

    &.hover {
        opacity: 0.7;

        .desc {
            color: #ff0000;
        }
    }
}
</style>

<style scoped lang="scss">
.title-main {
    font-family: Oswald, sans-serif;
    text-transform: uppercase;
    background: linear-gradient(to left, rgb(255, 0, 0), rgb(121, 121, 244));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 900;
    font-size: 2.4rem;
    text-align: center;
    padding: 5rem 0 0;
    box-sizing: border-box;
    margin: 0;
    position: relative;
    justify-content: center;
}

.items-slider {
    font-family: "Oswald", sans-serif;

    div > .splide {
        z-index: 10;
        position: relative;
        width: 100%;
    }

    li {
        > div {
            width: 90%;
            display: flex;
            flex-flow: column;
            margin: auto;

            > div {
                overflow: hidden;
                border-radius: 15px;
                background: rgba(255, 255, 255, 0.5);
                height: 100%;
                box-shadow: 0px 0px 34px 10px rgba(0, 0, 0, 0.3);
                transition: all 0.3s;
            }

            &:hover,
            &:focus {
                > div {
                    transform: scale(1.05);
                    z-index: 1;
                }
            }
        }

        .title {
            color: #ff0000;
            text-transform: uppercase;
            font-weight: 900;
            font-size: 1.4rem;
            display: flex;
            align-items: center;
            padding: 0 1rem;
            box-sizing: border-box;
            font-family: Oswald, sans-serif;
            background: linear-gradient(to left, #ff9100, #ff0000);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;

            svg {
                margin-right: 0.2rem;
                flex: 0 0 40px;
            }
        }

        .desc {
            font-family: "Roboto", sans-serif;
            font-weight: 300;
            font-size: 1.2rem;
            display: flex;
            align-items: flex-start;
            padding: 0 1rem;
            box-sizing: border-box;
            height: 100px;

            svg {
                margin-top: 0.2rem;
                margin-right: 0.5rem;
                flex: 0 0 20px;
            }
        }

        .see {
            font-family: "Roboto", sans-serif;
            font-weight: 400;
            font-size: 1.2rem;
            display: flex;
            align-items: flex-start;
            padding: 0 1rem;
            box-sizing: border-box;
            height: 40px;
        }

        .media {
            width: 100%;
            aspect-ratio: 16/9;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                min-height: 100%;
                min-width: 100%;
            }
        }

        /* &:last-child {
            > div {
                width: 90%;
                display: flex;
                flex-flow: column;
                margin: auto;
                height: 100%;

                > div {
                    overflow: hidden;
                    border-radius: 15px;
                    background: rgba(0, 0, 0, 0.05);
                    height: 100%;
                    box-shadow: 0 0 0;
                    display: flex;
                    flex-flow: column;
                    align-items: center;
                    justify-content: center;
                }

                .img {
                    flex: 2;
                    width: 100%;
                    display: block;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    > span {
                        padding: 2.4rem;
                        box-sizing: border-box;
                        height: 150px;
                        width: 150px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: #fff;
                        border-radius: 100px;
                        box-shadow: 0px 0px 7px 2px rgba(0, 0, 0, 0.1);

                        svg {
                            height: 100%;
                            width: auto;
                            fill: red;
                        }
                    }
                }

                .more {
                    flex: 1;
                    text-align: center;
                    font-family: "Roboto", sans-serif;
                    font-weight: 300;
                    font-size: 1.2rem;
                }
            }
        } */
    }
}

@media (max-width: 1400px) {
}
@media (max-width: 1200px) {
}

@media (max-width: 992px) {
}

@media (max-width: 768px) {
}

@media (max-width: 576px) {
}
</style>
